import Link from "next/link";

const leftSVG = (
  <svg
    className="w-full h-24 md:h-full"
    height={48}
    viewBox="0 0 213 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_532_6516"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={-50}
      y={-50}
      width={263}
      height={184}
    >
      <g opacity={0.4}>
        <g opacity={0.4}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M140.696 125.775L140.696 -49L141.65 -49L141.65 125.775L140.696 125.775Z"
            fill="url(#paint0_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M140.696 125.775L140.696 -49L141.65 -49L141.65 125.775L140.696 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M140.696 125.775L140.696 -49L141.65 -49L141.65 125.775L140.696 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M159.448 125.775L159.448 -49L160.402 -49L160.402 125.775L159.448 125.775Z"
            fill="url(#paint1_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M159.448 125.775L159.448 -49L160.402 -49L160.402 125.775L159.448 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M159.448 125.775L159.448 -49L160.402 -49L160.402 125.775L159.448 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M178.22 125.775L178.22 -49L179.173 -49L179.173 125.775L178.22 125.775Z"
            fill="url(#paint2_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M178.22 125.775L178.22 -49L179.173 -49L179.173 125.775L178.22 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M178.22 125.775L178.22 -49L179.173 -49L179.173 125.775L178.22 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M196.983 125.775L196.983 -49L197.937 -49L197.937 125.775L196.983 125.775Z"
            fill="url(#paint3_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M196.983 125.775L196.983 -49L197.937 -49L197.937 125.775L196.983 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M196.983 125.775L196.983 -49L197.937 -49L197.937 125.775L196.983 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M103.483 125.775L103.483 -49L104.436 -49L104.436 125.775L103.483 125.775Z"
            fill="url(#paint4_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M103.483 125.775L103.483 -49L104.436 -49L104.436 125.775L103.483 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M103.483 125.775L103.483 -49L104.436 -49L104.436 125.775L103.483 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.2665 125.775L66.2665 -49L67.2198 -49L67.2198 125.775L66.2665 125.775Z"
            fill="url(#paint5_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.2665 125.775L66.2665 -49L67.2198 -49L67.2198 125.775L66.2665 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.2665 125.775L66.2665 -49L67.2198 -49L67.2198 125.775L66.2665 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.058 125.775L29.058 -49L30.0114 -49L30.0113 125.775L29.058 125.775Z"
            fill="url(#paint6_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.058 125.775L29.058 -49L30.0114 -49L30.0113 125.775L29.058 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.058 125.775L29.058 -49L30.0114 -49L30.0113 125.775L29.058 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M122.088 125.775L122.088 -49L123.041 -49L123.041 125.775L122.088 125.775Z"
            fill="url(#paint7_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M122.088 125.775L122.088 -49L123.041 -49L123.041 125.775L122.088 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M122.088 125.775L122.088 -49L123.041 -49L123.041 125.775L122.088 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M84.8748 125.775L84.8748 -49L85.8281 -49L85.8281 125.775L84.8748 125.775Z"
            fill="url(#paint8_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M84.8748 125.775L84.8748 -49L85.8281 -49L85.8281 125.775L84.8748 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M84.8748 125.775L84.8748 -49L85.8281 -49L85.8281 125.775L84.8748 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.65 125.775L47.65 -49L48.6033 -49L48.6033 125.775L47.65 125.775Z"
            fill="url(#paint9_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.65 125.775L47.65 -49L48.6033 -49L48.6033 125.775L47.65 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.65 125.775L47.65 -49L48.6033 -49L48.6033 125.775L47.65 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4612 125.775L10.4612 -49L11.4145 -49L11.4145 125.775L10.4612 125.775Z"
            fill="url(#paint10_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4612 125.775L10.4612 -49L11.4145 -49L11.4145 125.775L10.4612 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4612 125.775L10.4612 -49L11.4145 -49L11.4145 125.775L10.4612 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
        </g>
        <g opacity={0.4}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 3.10322L-48.752 3.10322V2.1499L212.421 2.1499V3.10322Z"
            fill="url(#paint11_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 3.10322L-48.752 3.10322V2.1499L212.421 2.1499V3.10322Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 3.10322L-48.752 3.10322V2.1499L212.421 2.1499V3.10322Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 40.3166L-48.752 40.3166V39.3633L212.421 39.3633V40.3166Z"
            fill="url(#paint12_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 40.3166L-48.752 40.3166V39.3633L212.421 39.3633V40.3166Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 40.3166L-48.752 40.3166V39.3633L212.421 39.3633V40.3166Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 21.7084L-48.752 21.7084V20.7551L212.421 20.7551V21.7084Z"
            fill="url(#paint13_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 21.7084L-48.752 21.7084V20.7551L212.421 20.7551V21.7084Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M212.421 21.7084L-48.752 21.7084V20.7551L212.421 20.7551V21.7084Z"
            stroke="black"
            strokeWidth={0.835741}
          />
        </g>
      </g>
    </mask>
    <g mask="url(#mask0_532_6516)">
      <path
        d="M174.62 37.0445C174.62 89.9656 133.079 132.867 81.8351 132.867C30.5917 132.867 -10.9493 89.9656 -10.9493 37.0445C-10.9493 -15.8766 30.5917 -58.7776 81.8351 -58.7776C133.079 -58.7776 174.62 -15.8766 174.62 37.0445Z"
        fill="url(#paint14_linear_532_6516)"
      />
    </g>
    <path
      d="M147.887 15.6727C148.709 13.8548 151.291 13.8548 152.113 15.6727L155.784 23.7916C156.32 24.9778 157.728 25.4901 158.901 24.9261L166.923 21.0706C168.72 20.2067 170.698 21.8641 170.161 23.7846L167.759 32.3793C167.409 33.6314 168.157 34.9265 169.416 35.2495L178.048 37.4634C179.978 37.9585 180.426 40.4966 178.782 41.6226L170.062 47.5943C169.676 47.8586 169.22 48 168.752 48H131.248C130.78 48 130.324 47.8586 129.938 47.5943L121.218 41.6226C119.574 40.4966 120.022 37.9585 121.952 37.4634L130.584 35.2495C131.843 34.9265 132.591 33.6314 132.241 32.3793L129.839 23.7846C129.302 21.8641 131.28 20.2067 133.077 21.0706L141.099 24.9261C142.272 25.4901 143.68 24.9778 144.216 23.7916L147.887 15.6727Z"
      fill="#FFDF70"
      fillOpacity={0.8}
      className="hidden md:block"
    />
    <defs>
      <radialGradient
        id="paint0_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(141.173 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint1_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(159.925 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint2_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(178.697 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(197.46 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint4_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(103.96 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint5_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.7431 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint6_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(29.5347 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint7_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(122.565 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint8_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(85.3515 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint9_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.1267 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint10_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.9378 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint11_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.8343 2.62656) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint12_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.8343 39.8399) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint13_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.8343 21.2318) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="paint14_linear_532_6516"
        x1={-10.9493}
        y1={37.0445}
        x2={296.5}
        y2={37.0445}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8984FF" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

const rightSVG = (
  <svg
    className="w-full"
    height={48}
    viewBox="0 0 201 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_532_6516"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={-1}
      y={-50}
      width={263}
      height={184}
    >
      <g opacity={0.4}>
        <g opacity={0.4}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M189.448 125.775L189.448 -49L190.402 -49L190.402 125.775L189.448 125.775Z"
            fill="url(#paint0_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M189.448 125.775L189.448 -49L190.402 -49L190.402 125.775L189.448 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M189.448 125.775L189.448 -49L190.402 -49L190.402 125.775L189.448 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152.235 125.775L152.235 -49L153.188 -49L153.188 125.775L152.235 125.775Z"
            fill="url(#paint1_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152.235 125.775L152.235 -49L153.188 -49L153.188 125.775L152.235 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152.235 125.775L152.235 -49L153.188 -49L153.188 125.775L152.235 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.018 125.775L115.018 -49L115.972 -49L115.972 125.775L115.018 125.775Z"
            fill="url(#paint2_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.018 125.775L115.018 -49L115.972 -49L115.972 125.775L115.018 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.018 125.775L115.018 -49L115.972 -49L115.972 125.775L115.018 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.81 125.775L77.81 -49L78.7633 -49L78.7633 125.775L77.81 125.775Z"
            fill="url(#paint3_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.81 125.775L77.81 -49L78.7633 -49L78.7633 125.775L77.81 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.81 125.775L77.81 -49L78.7633 -49L78.7633 125.775L77.81 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.5967 125.775L40.5967 -49L41.55 -49L41.55 125.775L40.5967 125.775Z"
            fill="url(#paint4_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.5967 125.775L40.5967 -49L41.55 -49L41.55 125.775L40.5967 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.5967 125.775L40.5967 -49L41.55 -49L41.55 125.775L40.5967 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M170.84 125.775L170.84 -49L171.793 -49L171.793 125.775L170.84 125.775Z"
            fill="url(#paint5_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M170.84 125.775L170.84 -49L171.793 -49L171.793 125.775L170.84 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M170.84 125.775L170.84 -49L171.793 -49L171.793 125.775L170.84 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M133.627 125.775L133.627 -49L134.58 -49L134.58 125.775L133.627 125.775Z"
            fill="url(#paint6_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M133.627 125.775L133.627 -49L134.58 -49L134.58 125.775L133.627 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M133.627 125.775L133.627 -49L134.58 -49L134.58 125.775L133.627 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M96.402 125.775L96.402 -49L97.3553 -49L97.3553 125.775L96.402 125.775Z"
            fill="url(#paint7_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M96.402 125.775L96.402 -49L97.3553 -49L97.3553 125.775L96.402 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M96.402 125.775L96.402 -49L97.3553 -49L97.3553 125.775L96.402 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.2131 125.775L59.2131 -49L60.1664 -49L60.1664 125.775L59.2131 125.775Z"
            fill="url(#paint8_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.2131 125.775L59.2131 -49L60.1664 -49L60.1664 125.775L59.2131 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.2131 125.775L59.2131 -49L60.1664 -49L60.1664 125.775L59.2131 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.003 125.775L22.003 -49L22.9564 -49L22.9564 125.775L22.003 125.775Z"
            fill="url(#paint9_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.003 125.775L22.003 -49L22.9564 -49L22.9564 125.775L22.003 125.775Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.003 125.775L22.003 -49L22.9564 -49L22.9564 125.775L22.003 125.775Z"
            stroke="black"
            strokeWidth={0.835741}
          />
        </g>
        <g opacity={0.4}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 3.10322L0 3.10322L0 2.1499L261.172 2.1499V3.10322Z"
            fill="url(#paint10_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 3.10322L0 3.10322L0 2.1499L261.172 2.1499V3.10322Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 3.10322L0 3.10322L0 2.1499L261.172 2.1499V3.10322Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 40.3166L0 40.3166L0 39.3633L261.172 39.3633V40.3166Z"
            fill="url(#paint11_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 40.3166L0 40.3166L0 39.3633L261.172 39.3633V40.3166Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 40.3166L0 40.3166L0 39.3633L261.172 39.3633V40.3166Z"
            stroke="black"
            strokeWidth={0.835741}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 21.7084L0 21.7084L0 20.7551L261.172 20.7551V21.7084Z"
            fill="url(#paint12_radial_532_6516)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 21.7084L0 21.7084L0 20.7551L261.172 20.7551V21.7084Z"
            fill="#8984FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M261.172 21.7084L0 21.7084L0 20.7551L261.172 20.7551V21.7084Z"
            stroke="black"
            strokeWidth={0.835741}
          />
        </g>
      </g>
    </mask>
    <g mask="url(#mask0_532_6516)">
      <path
        d="M223.371 37.0445C223.371 89.9656 181.83 132.867 130.587 132.867C79.3436 132.867 37.8026 89.9656 37.8026 37.0445C37.8026 -15.8766 79.3436 -58.7776 130.587 -58.7776C181.83 -58.7776 223.371 -15.8766 223.371 37.0445Z"
        fill="url(#paint13_linear_532_6516)"
      />
    </g>
    <path
      d="M50.7335 26.0505C49.66 28.3869 46.34 28.3869 45.2665 26.0505L43.3277 21.8306C42.6286 20.309 40.8216 19.6512 39.308 20.3672L35.0616 22.3758C32.7257 23.4807 30.1757 21.3206 30.8815 18.8348L32.1076 14.5166C32.5708 12.8851 31.5945 11.1934 29.95 10.7783L25.5282 9.66209C23.0063 9.02548 22.4263 5.70471 24.5832 4.25095L30.1278 0.513727C30.6246 0.178885 31.2101 1.90735e-06 31.8091 1.90735e-06L64.1909 1.90735e-06C64.7899 1.90735e-06 65.3754 0.178885 65.8722 0.513727L71.4168 4.25095C73.5737 5.70471 72.9937 9.02548 70.4718 9.66209L66.05 10.7783C64.4055 11.1934 63.4292 12.8851 63.8924 14.5166L65.1185 18.8348C65.8243 21.3206 63.2743 23.4807 60.9384 22.3758L56.692 20.3672C55.1784 19.6512 53.3714 20.309 52.6723 21.8306L50.7335 26.0505Z"
      fill="#FFDF70"
    />
    <defs>
      <radialGradient
        id="paint0_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(189.925 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint1_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(152.712 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint2_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(115.495 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.2866 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint4_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.0733 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint5_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(171.317 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint6_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(134.103 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint7_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(96.8786 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint8_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.6898 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint9_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.4797 38.3877) rotate(-90.2438) scale(209.173 1.71378)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint10_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(130.586 2.62656) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint11_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(130.586 39.8399) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint12_radial_532_6516"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(130.586 21.2318) rotate(179.837) scale(312.572 1.71379)"
      >
        <stop offset={0.112234} stopColor="#8984FF" />
        <stop offset={0.484375} stopColor="#8984FF" />
        <stop offset={0.79199} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="paint13_linear_532_6516"
        x1={199.5}
        y1={37}
        x2={-52.5001}
        y2={37}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8984FF" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export type homeTopBannerPropsType = {
  title?: string;
  isCTA?: boolean;
  ctaText?: string;
  ctaLink?: string;
  isShowBanner?: boolean;
};

type HomeTopBannerDataProps = {
  homeTopBannerData: homeTopBannerPropsType;
};

const TopBanner: React.FC<HomeTopBannerDataProps> = ({ homeTopBannerData }) => {
  const {
    isShowBanner = false,
    title = "",
    isCTA = false,
    ctaText = "",
    ctaLink = "#",
  } = homeTopBannerData;

  if (!isShowBanner) {
    return null;
  }

  return (
    <div className="flex h-24 md:h-12 w-full relative" style={{ backgroundColor: "#FFF8D4" }}>
      <div className="h-12 md:w-36 xl:w-64">{leftSVG}</div>
      <div className="px-3 py-4 flex flex-1 flex-col md:flex-row w-full items-center justify-center gap-[2px] md:gap-3 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:relative md:top-auto md:left-auto md:transform-none">
        <p className="text-center font-sans text-[14px] font-normal leading-[20px] text-[#3A3D50]">
          {title}
        </p>
        {isCTA ? (<Link
          href={ctaLink}
          legacyBehavior
        >
          <a
            className="flex flex-row items-center justify-center gap-1 rounded-[8px] p-0"
            target="_blank"
          >
            <span className="flex items-end text-center font-sans text-[14px] font-semibold leading-[20px] text-[#312D89]">
              {ctaText}
            </span>
            <span>
              <svg
                height={11}
                viewBox="0 0 13 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.3789 6.37891L8.00391 10.7539C7.82161 10.918 7.61198 11 7.375 11C7.13802 11 6.92839 10.918 6.74609 10.7539C6.58203 10.5716 6.5 10.362 6.5 10.125C6.5 9.88802 6.58203 9.67839 6.74609 9.49609L9.64453 6.625H1.25C0.994792 6.625 0.785156 6.54297 0.621094 6.37891C0.457031 6.21484 0.375 6.00521 0.375 5.75C0.375 5.49479 0.457031 5.28516 0.621094 5.12109C0.785156 4.95703 0.994792 4.875 1.25 4.875H9.64453L6.74609 2.00391C6.58203 1.82161 6.5 1.61198 6.5 1.375C6.5 1.13802 6.58203 0.928385 6.74609 0.746094C6.92839 0.582031 7.13802 0.5 7.375 0.5C7.61198 0.5 7.82161 0.582031 8.00391 0.746094L12.3789 5.12109C12.543 5.30339 12.625 5.51302 12.625 5.75C12.625 5.98698 12.543 6.19661 12.3789 6.37891Z"
                  fill="#312D89"
                />
              </svg>
            </span>
          </a>
        </Link>) : null}
      </div>
      <div className="h-24 md:h-12 md:w-36 xl:w-64 hidden md:block">{rightSVG}</div>
    </div>
  );
};

export default TopBanner;
